import { Decimal } from 'decimal.js';
/** A quantity at its Decimal(28,9) column's scale, for sums and remainders that float math would drift. */
export function toQuantityDecimal(value) {
    return new Decimal(value).toDecimalPlaces(9, Decimal.ROUND_HALF_UP);
}
//# sourceMappingURL=to-quantity-decimal.js.map